import type { ReactElement } from 'react';
import { useEffect, useState } from 'react';
import { useLocation } from '@gatsbyjs/reach-router';
import { ListItemPrimaryText } from '@noah-labs/fe-shared-ui-components';
import { useLocalization } from 'gatsby-theme-i18n';
import type { ConfigItem } from './types';
import { StyledListItemButton } from '../navbar/DesktopMenuItem';
import { MobileMenuAccordion } from '../navbar/MobileMenuAccordion';
import { LocalizedLinkWithRef } from './LocalizedLinkWithRef';
import { findByCode, storeLocale } from './utils';

export function LanguageAccordion(): ReactElement {
  const { config, locale }: { config: Array<ConfigItem>; locale: string } = useLocalization();
  const [currentLanguage, setCurrentLanguage] = useState<ConfigItem | undefined>(undefined);
  const location = useLocation();

  useEffect(() => {
    const currentLanguageConfig = findByCode(config, locale);
    setCurrentLanguage(currentLanguageConfig);
  }, [config, locale]);

  return (
    <MobileMenuAccordion summary={currentLanguage?.localName}>
      {config.map((language) => (
        <StyledListItemButton
          key={language.code}
          component={LocalizedLinkWithRef}
          href={location.pathname.replace(/\/(es|lt)\//, '/')}
          language={language.code as string}
          onClick={(): void => {
            storeLocale(language.code as string);
          }}
        >
          <ListItemPrimaryText color="text.primary" component="span" variant="paragraphBodyS">
            {language.localName}
          </ListItemPrimaryText>
        </StyledListItemButton>
      ))}
    </MobileMenuAccordion>
  );
}
